import { InputType, type ItemInterface } from './components/form-builder/form-builder.component';

/** Sanitize any value to a CSV-safe string. */
function toCsvCell(value: unknown): string {
  if (value === null || value === undefined) {return '';}
  const s = String(value).trim();
  
  if (/^(?:undefined|null|NaN|Invalid Date)$/i.test(s) || /NaN\/NaN/i.test(s)) {return '';}
  return s
    .replace(/\r?\n-/g, ', ')  // bullet lists
    .replace(/\r?\n/g, ' ')    // new lines to space
    .replace(/;/g, ',')        // avoid new columns
    .replace(/^\s*[+-]\s*/, ''); // leading +/- noise
}

/** Normalize a switch value to 'Sí' | 'No' | ''. Accepts 0/1 or "0"/"1". */
function switchLabel(v: unknown): string {
  let num: number | null = null;

  if (typeof v === 'number' && Number.isFinite(v)) {
    num = v;
  } else if (typeof v === 'string') {
    const s = v.trim();
    
    if (s === '0' || s === '1') {
      num = Number(s);
    }
  }

  if (num === 0) {return 'No';}
  if (num === 1) {return 'Sí';}
  return '';
}


export function createCsv<T>(
  arrayFormFields: ItemInterface<object>[][],
  values: T[] | void,
  last_field: string | undefined
): string {
  const charset = 'windows-1252';
  let csvContent = 'data:text/csv;charset=' + charset + ',\ufeff';

  // ----- Header -----
  arrayFormFields.forEach(form => {
    form.forEach(it => {
      if (it.visible == null || it.visible === true) {
        if (it.inputType?.type === InputType.EMPTY) {
          // spacer column: nothing
        } else {
          csvContent += (it.name ?? '');
          csvContent += (it.field === last_field) ? '\n' : ';';
        }
      } else if (it.field === last_field) {
        csvContent += '\n';
      }
    });
  });

  // ----- Rows -----
  const rows = (values as Array<Record<string, unknown>>) ?? [];

  rows.forEach((tareas) => {
    arrayFormFields.forEach(form => {
      form.forEach(it => {
        if (it.visible != null && it.visible === false) {
          if (it.field === last_field) {csvContent += '\n';}
          return;
        }

        // Safe read: never use "?? 0" for field names.
        const key = (typeof it.field === 'string') ? it.field : '';
        const raw = (key && Object.prototype.hasOwnProperty.call(tareas, key)) ? tareas[key] : '';

        if (it.inputType?.type === InputType.RO_SWITCH || it.inputType?.type === InputType.RO_MD_SWITCH) {
          const lbl = switchLabel(raw);
          
          csvContent += (key === last_field) ? (lbl + '\n') : (lbl + ';');
          return;
        }

        if (it.inputType?.type === InputType.EMPTY) {
          // spacer column: nothing
          return;
        }

        const cell = toCsvCell(raw);
        
        csvContent += (key === last_field) ? (`"${cell}"\n`) : (`"${cell}";`);
      });
    });
  });

  return csvContent;
}
